(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["starter-bundles"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('sb-{{ section.id }}');
  if (!section) return;
  var tabs = section.querySelectorAll('.sb-tab');
  var panels = section.querySelectorAll('[role="tabpanel"]');
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var t = tab.dataset.tab;
      tabs.forEach(function(x){
        x.classList.remove('sb-tab--active');
        x.setAttribute('aria-selected','false');
      });
      tab.classList.add('sb-tab--active');
      tab.setAttribute('aria-selected','true');
      panels.forEach(function(p){
        if (p.id === 'sb-panel-' + t + '-{{ section.id }}') {
          p.classList.remove('sb-grid--hidden');
          p.removeAttribute('aria-hidden');
        } else {
          p.classList.add('sb-grid--hidden');
          p.setAttribute('aria-hidden','true');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
